import React, { useEffect, useState } from "react";
import { Col, Row, Form, Input, Checkbox } from "antd";
import { ButtonProps } from "../../helpers/constants";
import useAxiosPost from "../../hooks/useAxiosPost";
import useMultiNotification from "../../hooks/useNotification";
import "./../../styles/modal.css";
import { FiPlusCircle } from "react-icons/fi";
import MeshBillModal from "../Items/Modal/Index";
import MeshBillButton from "../Items/Button/Index";
// const MeshBillSelect = lazy(() => import("../Items/Select/Index"));
// const MeshBillModal = lazy(() => import("../Items/Modal/Index"));
// const MeshBillButton = lazy(() => import("../Items/Button/Index"));

const CreateDealerModalComponent: React.FC<GeneralModalProps> = ({
  show,
  handleClose,
}) => {
  const { openNotification, contextHolder } = useMultiNotification();
  const [form] = Form.useForm();
  const [
    postApiData,
    apiResponse,
    apiError,
    apiLoading,
    apiMessage,
    apiErrorCount,
  ] = useAxiosPost<createNewDealerApiProp>("dealers/createNewDealer", true);
  const [checked, setChecked] = useState<boolean>(false);
  const onChange = (e: any) => {
    setChecked(e.target.checked);
  };
  const onFinish = (values: any) => {
    const { phoneNumber, email } = values;
    // if (!email && !phoneNumber) {
    //   openNotification("error", "Error", `Either Enter Phone or Email`);
    //   return;
    // }
    const dataToSend: createNewDealerApiProp = {
      firstName: values.firstName,
      lastName: values.lastName,
      password: values.password,
      address: values.address,
      email: email ? email : null,
      phoneNumber: phoneNumber ? phoneNumber : null,
      staffUserName: values.staffUserName,
      isCreditAllowed: checked === true ? 1 : 0,
      creditLimit: checked === true ? values.creditLimit : 0,
    };
    postApiData(dataToSend);
  };
  useEffect(() => {
    if (apiResponse !== null) {
      const { message } = apiResponse;
      if (message) {
        openNotification("success", "Success", message);
        setTimeout(() => {
          handleClose(true);
        }, 2500);
      }
    }
  }, [apiResponse]);
  useEffect(() => {
    if (apiError !== null && apiErrorCount !== 0) {
      openNotification("error", "Error", apiError);
    }
  }, [apiError, apiErrorCount]);
  const onFinishFailed = (errorInfo: any) => {
    console.log("Failed:", errorInfo);
  };
  return (
    <>
      <MeshBillModal
        title="Create Dealer"
        headerStyle={{
          backgroundColor: "var(--primary-background-color)",
          color: "var(--primary-text-color)",
          fontSize: "16px",
          fontWeight: "var(--fw-700)",
          height: "50px",
        }}
        open={show}
        onCancel={() => {
          if (apiLoading) {
            return;
          }
          handleClose(false);
        }}
      >
        {contextHolder}

        <Row>
          <Col
            span={24}
            className="meshbill-create-record-modal-form-container"
          >
            <Form
              //   requiredMark={true}
              style={{ width: "100%", marginTop: "50px" }}
              layout="vertical"
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              name="createNewDealerForm"
              form={form}
            >
              <Form.Item
                label={
                  <span className="create-user-form-label">First Name</span>
                }
                name="firstName"
                rules={[
                  {
                    required: true,
                    message: "Please Enter First Name",
                  },
                ]}
              >
                <Input
                  className="user-input-general-height"
                  placeholder="John"
                />
              </Form.Item>

              <Form.Item
                label={
                  <span className="create-user-form-label">Last Name</span>
                }
                name="lastName"
                rules={[
                  {
                    required: true,
                    message: "Please enter Last Name",
                  },
                ]}
              >
                <Input
                  className="user-input-general-height"
                  placeholder="Deo"
                />
              </Form.Item>

              <Form.Item
                label={
                  <span className="create-user-form-label">Phone Number</span>
                }
                name="phoneNumber"
                // rules={[
                //   {
                //     required: true,
                //     message: "Please enter Phone Number",
                //   },
                // ]}
              >
                <Input
                  className="user-input-general-height"
                  placeholder="03001234567"
                />
              </Form.Item>

              <Form.Item
                label={<span className="create-user-form-label">Email</span>}
                name="email"
                // rules={[
                //   {
                //     required: true,
                //     message: "Please enter Phone Number",
                //   },
                // ]}
              >
                <Input
                  className="user-input-general-height"
                  placeholder="john@email.com"
                />
              </Form.Item>

              <Form.Item
                label={<span className="create-user-form-label">UserName</span>}
                name="staffUserName"
                rules={[
                  {
                    required: true,
                    message: "Please enter Staff UserName",
                  },
                ]}
              >
                <Input
                  className="user-input-general-height"
                  placeholder="johndoe1"
                />
              </Form.Item>
              <Form.Item
                label={<span className="create-user-form-label">Password</span>}
                name="password"
                rules={[
                  {
                    required: true,
                    message: "Please enter Staff Password",
                  },
                  {
                    min: 6,
                    message: "Minimum 6 Characters Are required for password",
                  },
                ]}
              >
                <Input
                  className="user-input-general-height"
                  placeholder="password"
                />
              </Form.Item>

              <Form.Item
                label={<span className="create-user-form-label">Address</span>}
                name="address"
                rules={[
                  {
                    required: true,
                    message: "Please enter Address",
                  },
                ]}
              >
                <Input
                  className="user-input-general-height"
                  placeholder="House No."
                />
              </Form.Item>
              <Form.Item name="isVariableRechargeAllowed">
                <Checkbox checked={checked} onChange={onChange}>
                  <span className="create-user-form-label">
                    Credit Allowed?
                  </span>
                </Checkbox>
              </Form.Item>
              {checked === true && (
                <Form.Item
                  label={
                    <span className="create-user-form-label">Credit Limit</span>
                  }
                  name="creditLimit"
                  rules={[
                    {
                      required: true,
                      message: "Please enter Credit Limit",
                    },
                    {
                      validator: (_, value) =>
                        value >= 0
                          ? Promise.resolve()
                          : Promise.reject(new Error("Invalid Credit Limit")),
                    },
                  ]}
                >
                  <Input
                    type="number"
                    className="user-input-general-height"
                    placeholder="50000"
                  />
                </Form.Item>
              )}
              <Form.Item>
                <MeshBillButton
                  backgroundColor={ButtonProps.background.STANDARD}
                  height={ButtonProps.height.STANDARD}
                  width={`100%`}
                  textColor={ButtonProps.color.STANDARD}
                  onClick={() => {}}
                  htmlType="submit"
                  text="Create Dealer"
                  disabled={apiLoading}
                  icon={<FiPlusCircle />}
                />
              </Form.Item>
            </Form>
          </Col>
        </Row>
      </MeshBillModal>
    </>
  );
};
export default CreateDealerModalComponent;
